import Vue from 'vue';
import Vuex from 'vuex';
import {isEmpty} from 'lodash-es';

import apiCatalog from '@/api/catalog';

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: true,
    /*modules: {
        searchModule: listCatalogModule,
        catalogModule: listCatalogModule
    },*/
    state: {
        storeBackup: null,
        isLoading: true,
        catalogTitle: '',
        searchListText: null,
        urls: {},
        kStrings: {},
        campaigns: {},
        categories: {},
        filters: {},
        pagination: {},
        sorts: {},
        products: {},
        suggestions: [],
        mubBlock: {},
        extras: {},
        totalProducts: 0,
        componentsCss: null,
        campaignBlocks: null,
        expiredCampaign: false,
        tabs: null,
    },
    mutations: {
        storeBackup(state, payload) {
            state.storeBackup = payload;
        },
        isLoading(state, payload) {
            state.isLoading = payload;
        },
        catalogTitle(state, payload) {
            state.catalogTitle = payload;
        },
        searchListText(state, payload) {
            state.searchListText = payload;
        },
        kStrings(state, payload) {
            state.kStrings = !isEmpty(payload)
                ? {...state.kStrings, ...payload}
                : {};
        },
        urls(state, payload) {
            state.urls = !isEmpty(payload) ? {...state.urls, ...payload} : {};
        },
        campaigns(state, payload) {
            state.campaigns = !isEmpty(payload)
                ? {...state.campaigns, ...payload}
                : {};
        },
        categories(state, payload) {
            state.categories = !isEmpty(payload)
                ? {...state.categories, ...payload}
                : {};
        },
        filters(state, payload) {
            state.filters = payload;
        },
        sorts(state, payload) {
            state.sorts = !isEmpty(payload) ? {...state.sorts, ...payload} : {};
        },
        pagination(state, payload) {
            state.pagination = payload;
        },
        products(state, payload) {
            //state.products = !payload.filters.hasFilterApplied ? Object.assign({}, state.products, payload.products) : payload.products;
            // for pagination -> Object.assign, else (ex: filters & sorts) reassign products
            /* if(!isEmpty(payload)) {
                 state.products = state.pagination && state.pagination.currentPage !== 1 ? {...state.products, ...payload} : payload;
             } else {
                 state.products = {};
             }*/
            // for now its this condition, as current production environment 
            state.products = !isEmpty(payload) ? payload : {};

            //state.products = payload;
        },
        suggestions(state, payload) {
            state.suggestions = payload;
        },
        mubBlock(state, payload) {
            state.mubBlock = !isEmpty(payload)
                ? {...state.mubBlock, ...payload}
                : {};
        },
        extras(state, payload) {
            state.extras = !isEmpty(payload)
                ? {...state.extras, ...payload}
                : {};
        },
        totalProducts(state, payload) {
            state.totalProducts = payload;
        },
        componentsCss(state, payload) {
            let catalogCss = document.getElementById('catalogCss');
            let homeCss = document.getElementById('homeCss');

            if (!catalogCss) {
                apiCatalog.loadStyleSheet((payload.catalogCss??null), 'catalogCss');
            }

            if (!homeCss) {
                apiCatalog.loadStyleSheet((payload.homeCss??null), 'homeCss');
            }

            state.componentsCss = payload;
        },
        campaignBlocks(state, payload) {
            state.campaignBlocks = payload;
        },
        expiredCampaign(state, payload) {
            state.expiredCampaign = payload;
        },
        resetStore(state) { // main data reset
            Object.assign(state, {
                isLoading: false,
                catalogTitle: '',
                searchListText: null,
                urls: {},
                kStrings: {},
                campaigns: {},
                filters: {},
                pagination: {},
                sorts: {},
                products: {},
                suggestions: [],
                mubBlock: {},
                extras: {},
                totalProducts: 0,
                expiredCampaign: false,
                tabs: null,
            });
        },
        updateMenuAndCategories(state, payload){
            // state.categories.detailedMenu = payload.menu;
            // state.categories.allCategories = payload.categories;

            if(typeof payload.categories[0] === 'undefined'){
                // object with category ID as key
                for(let k in payload.categories){
                    payload.categories[k]['id'] = k;
                }
            }
            state.categories.allCategories = payload.categories;

            if(typeof payload.menu[0] === 'string'){
                // list of IDs, must build menu
                let list = [];
                for(let k = 0; k < payload.menu.length; k++){
                    const id = payload.menu[k];
                    if(!payload.categories.hasOwnProperty(id)){
                        continue;
                    }
                    list.push(payload.categories[id]);
                }
                state.categories.detailedMenu = list;
            }
            else{
                state.categories.detailedMenu = payload.menu;
            }
        },
        tabs(state, payload){
            state.tabs = payload;
        }
    },
    actions: {
        setWsData(context, payload) {
            context.commit('catalogTitle', payload ? payload.title : null);
            context.commit('campaigns', payload ? payload.campaigns : null);
            if(payload && payload.categories){
                context.commit('categories', payload.categories);
            }
            if(payload && payload.filters){
                context.commit('filters', payload.filters);
            }
            if(payload && payload.sorts){
                context.commit('sorts', payload.sorts);
            }
            context.commit('pagination', payload ? payload.pagination : null);
            context.commit('products', payload ? payload.results : null);
            context.commit('suggestions', payload ? payload.suggestions : null);
            context.commit('mubBlock', payload ? payload.mubBlock : null);
            context.commit('extras', payload ? payload.extras : null);
            context.commit('totalProducts', payload && payload.extras ? payload.extras.totalProducts : null);
            context.commit('tabs', payload ? payload.tabs : null);
        },
        setStoreBackup(context, payload) {
            context.commit('storeBackup', payload);
        },
        setLoading(context, payload) {
            context.commit('isLoading', payload);
        },
        setCatalogTitle(context, payload) {
            context.commit('catalogTitle', payload);
        },
        setSearchListText(context, payload) {
            context.commit('searchListText', payload);
        },
        setKStrings(context, payload) {
            context.commit('kStrings', payload);
        },
        setUrls(context, payload) {
            context.commit('urls', payload);
        },
        setCampaigns(context, payload) {
            context.commit('campaigns', payload);
        },
        setCategories(context, payload) {
            context.commit('categories', payload);
        },
        setFilters(context, payload) {
            context.commit('filters', payload);
        },
        setSorts(context, payload) {
            context.commit('sorts', payload);
        },
        setProducts(context, payload) {
            context.commit('products', payload);
        },
        setPagination(context, payload) {
            context.commit('pagination', payload);
        },
        setSuggestions(context, payload) {
            context.commit('suggestions', payload);
        },
        setMubBlock(context, payload) {
            context.commit('mubBlock', payload);
        },
        setExtras(context, payload) {
            context.commit('extras', payload);
        },
        setTotalProducts(context, payload) {
            context.commit('totalProducts', payload);
        },
        setComponentsCss(context, payload) { //catalog & home css
            context.commit('componentsCss', payload);
        },
        setCampaignBlocks(context, payload) { 
            context.commit('campaignBlocks', payload);
        },
        setExpiredCampaign(context, payload) { 
            context.commit('expiredCampaign', payload);
        },
        updateMenuAndCategories(context, payload) { 
            context.commit('updateMenuAndCategories', payload);
        },
    },
    getters: {
        storeBackup: state => state.storeBackup,
        isLoading: state => state.isLoading,
        catalogTitle: state => state.catalogTitle,
        searchListText: state => state.searchListText,
        urls: state => state.urls,
        kStrings: state => state.kStrings,
        campaigns: state => state.campaigns,
        categories: state => state.categories,
        filters: state => state.filters,
        sorts: state => state.sorts,
        pagination: state => state.pagination,
        products: state => state.products,
        suggestions: state => state.suggestions,
        mubBlock: state => state.mubBlock,
        extras: state => state.extras,
        totalProducts: state => state.totalProducts,
        componentsCss: state => state.componentsCss,
        campaignBlocks: state => state.campaignBlocks,
        expiredCampaign: state => state.expiredCampaign,
        tabs: state => state.tabs,
    },
});
